import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-243c7ab3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-device-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "选择需要报修的设备", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "more-text" }, "故障报修记录", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "12",
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.93938 6L1.00004 2.06066C0.835307 1.89592 0.752939 1.81355 0.714879 1.72167C0.664132 1.59915 0.664132 1.4615 0.714879 1.33898C0.752939 1.2471 0.835307 1.16473 1.00004 0.999996C1.16478 0.835261 1.24714 0.752894 1.33903 0.714833C1.46154 0.664086 1.5992 0.664086 1.72171 0.714833C1.8136 0.752894 1.89597 0.835261 2.0607 0.999996L6.53037 5.46967C6.82327 5.76256 6.82327 6.23743 6.53037 6.53033L2.0607 11C1.89597 11.1647 1.8136 11.2471 1.72171 11.2852C1.5992 11.3359 1.46154 11.3359 1.33903 11.2852C1.24714 11.2471 1.16478 11.1647 1.00004 11C0.835307 10.8353 0.75294 10.7529 0.714879 10.661C0.664132 10.5385 0.664132 10.4008 0.714879 10.2783C0.752939 10.1864 0.835307 10.1041 1.00004 9.93934L4.93938 6Z",
    fill: "#00C378"
  })
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { getRepairDeviceDetail } from '@/apis/malfunction-repair'
import { clearToast, showNormalToast, showToastLoading } from '@/utils/tools'
import { withDefaults, computed } from 'vue'
import appHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'devices-header',
  props: {
    queryDataDeviceSnMap: { default: () => ({}) }
  },
  emits: ['scan'],
  setup(__props: any, { emit: emits }) {

const props = __props as { queryDataDeviceSnMap: Record<string, boolean> };

const $router = useRouter()


const vueStore = useStore()
const isMiniProgram = computed(() => {
  return vueStore.getters.isMiniProgram
})

function toOrderList() {
  $router.push({
    name: 'malfunction-repair-order-list',
  })
}

function scanDevice() {
  appHost.postAddDevice((serial_number: string): void => {
    // emits('scan', serial_number)
    if (props.queryDataDeviceSnMap[serial_number]) {
      showNormalToast('重复设备，不可添加')
      return
    }
    getAddDeviceHandle(serial_number)
  })
}

async function getAddDeviceHandle(serial_number: string) {
  showToastLoading()
  try {
    const data = await getRepairDeviceDetail(serial_number)
    emits('scan', data)
  } catch (error) {
    commonErrorHandle(error)
  }
  clearToast()
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(isMiniProgram))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "more",
          onClick: toOrderList
        }, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "add-box",
          onClick: scanDevice
        }, [
          _createVNode(_component_van_icon, {
            name: "/images/nav_icon_menu.svg",
            size: "18",
            style: {"margin-right":"4px","vertical-align":"middle"}
          }),
          _createTextVNode("录入其他设备 ")
        ]))
  ]))
}
}

})